import React, { useState } from 'react';
import { Heart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Template 14: JHAROKHA Product Card
 * White card, teal accent bar bottom, structured hover (border appears)
 */
const ProductCard = ({ product, basePath = '/template14' }) => {
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    const [wishlisted, setWishlisted] = useState(false);

    const handleWishlist = (e) => {
        e.stopPropagation();
        setWishlisted(!wishlisted);
    };

    return (
        <div
            onClick={() => navigate(`${basePath}/product/${product.id}`)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            className="cursor-pointer group bg-white relative overflow-hidden transition-all duration-300"
            style={{
                border: isHovered ? '1px solid #0D9488' : '1px solid #E5E7EB',
            }}
        >
            {/* Image Container */}
            <div className="relative aspect-[3/4] overflow-hidden bg-[#F0FDFA]">
                <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-500"
                    style={{ transform: isHovered ? 'scale(1.05)' : 'scale(1)' }}
                />

                {/* Wishlist Button */}
                <button
                    onClick={handleWishlist}
                    className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-full bg-white/90 backdrop-blur-sm transition-all duration-300 hover:bg-white"
                >
                    <Heart
                        className={`w-4 h-4 transition-colors duration-300 ${wishlisted ? 'fill-[#0D9488] text-[#0D9488]' : 'text-[#6B7280]'}`}
                    />
                </button>

                {/* Quick View on Hover */}
                <div
                    className="absolute bottom-0 left-0 right-0 flex items-center justify-center transition-all duration-300"
                    style={{
                        backgroundColor: 'rgba(13, 148, 136, 0.9)',
                        padding: '10px',
                        transform: isHovered ? 'translateY(0)' : 'translateY(100%)',
                    }}
                >
                    <span
                        className="text-white text-xs tracking-[0.15em] uppercase font-medium"
                        style={{ fontFamily: "'Archivo', sans-serif" }}
                    >
                        Quick View
                    </span>
                </div>
            </div>

            {/* Product Info */}
            <div className="p-4">
                <h3
                    className="text-sm font-medium text-[#1A1A1A] mb-1 line-clamp-1"
                    style={{ fontFamily: "'Archivo', sans-serif" }}
                >
                    {product.name}
                </h3>
                {product.category && (
                    <p
                        className="text-xs text-[#6B7280] mb-2"
                        style={{ fontFamily: "'Roboto', sans-serif" }}
                    >
                        {product.category}
                    </p>
                )}
                <div className="flex items-center gap-2">
                    <span
                        className="text-base font-semibold text-[#0D9488]"
                        style={{ fontFamily: "'Archivo', sans-serif" }}
                    >
                        {typeof product.price === 'number' ? `\u20B9${product.price.toLocaleString('en-IN')}` : product.price}
                    </span>
                    {product.originalPrice && (
                        <span
                            className="text-sm text-[#6B7280] line-through"
                            style={{ fontFamily: "'Roboto', sans-serif" }}
                        >
                            {typeof product.originalPrice === 'number' ? `\u20B9${product.originalPrice.toLocaleString('en-IN')}` : product.originalPrice}
                        </span>
                    )}
                </div>
            </div>

            {/* Teal Accent Bar Bottom */}
            <div
                className="h-[3px] w-full transition-all duration-300"
                style={{ backgroundColor: isHovered ? '#0D9488' : '#E5E7EB' }}
            />
        </div>
    );
};

export default ProductCard;
